import * as _ from 'lodash';

export function groupMatchesSearch(group, search) {
  const searchFields = _.compact([group.name?.toLowerCase()]);
  return searchFields.some((field) => field.includes(search));
}
